import {
  range, map, pipe, prop, find, propEq, ifElse, pick, equals, identity, sortBy, path, propOr,
} from 'ramda';

import { militaryToRegularTime } from '../../../common/helpers/times';
import { initialPromoValues } from './constants';

export const generateInitialSchedule = pipe(
  () => range(1, 8),
  map(day => ({
    weekDay: day,
    enabled: false,
    startTime: '8:00 am',
    finishTime: '10:00 pm',
  })),
);

const fixScheduleCompleteness = pipe(
  sortBy(prop('weekDay')),
  schedule => pipe(
    () => range(1, 8),
    map((day) => {
      if (path([day - 1, 'weekDay'], schedule) === day) {
        return schedule[day - 1];
      }

      return {
        weekDay: day,
        enabled: false,
        startTime: '8:00 am',
        finishTime: '10:00 pm',
      };
    })
  )(),
);

const transformRuleForInput = pipe(
  prop('schedule'),
  map(item => ({
    ...pick(['weekDay', 'enabled'], item),
    startTime: militaryToRegularTime(`${item.startHour}:${item.startMinute}`).replace(/^0/, ''),
    finishTime: militaryToRegularTime(`${item.finishHour}:${item.finishMinute}`).replace(/^0/, ''),
  })),
  ifElse(
    schedule => equals(schedule.length, 7),
    identity,
    fixScheduleCompleteness,
  )
);

export const getScheduleFromPromo = pipe(
  prop('rules'),
  find(propEq('kind', 8)),
  ifElse(
    identity,
    transformRuleForInput,
    generateInitialSchedule,
  )
);

export const isScheduledPromo = pipe(
  prop('rules'),
  find(propEq('kind', 8)),
);


export const isUsableEveryNumberOfDays = pipe(
  prop('rules'),
  find(propEq('kind', 1))
);

export const getUsableEveryNumberOfDaysFromPromo = pipe(
  isUsableEveryNumberOfDays,
  propOr('', 'value')
);

export const isUsableNumberOfTimes = pipe(
  prop('rules'),
  find(propEq('kind', 7))
);

export const getUsableNumberOfTimesFromPromo = pipe(
  isUsableNumberOfTimes,
  propOr('', 'value')
);

export const isForServicesOrProducts = pipe(
  prop('rules'),
  find(propEq('kind', 10))
);

export const getServicesFromPromo = pipe(
  isForServicesOrProducts,
  propOr([], 'serviceIds')
);

export const getProductsFromPromo = pipe(
  isForServicesOrProducts,
  propOr([], 'productIds')
);

export const getSelectedShopIdsFromPromo = pipe(
  propOr([], 'rules'),
  find(propEq('kind', 9)),
  propOr([], 'shopIds'),
);

export const getInitialValues = (brandShops, promo = initialPromoValues) => {
  const shopIds = propOr([], 'shopIds', promo);
  const shops = brandShops || [];
  return {
    ...promo,
    isBrandPromo: promo.isBrandPromo || !!shops.length,
    shops: shops.map(shop => ({
      id: shop.id,
      assigned: promo.id ? shopIds.includes(shop.id) : true,
      name: shop.name,
    })),
  };
};

export const isBrandPromoError = pipe(
  propOr([], 'rawMessage'),
  find(propEq('kind', 'brand_promo')),
  Boolean,
);
